import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';

const AddressInfo = ({ formData, handleChange }) => {
  return (
    <div>
      <h3 className="h5 mb-3">Address Information</h3>
      
      <Form.Group controlId="streetAddress" className="mb-3">
        <Form.Label>Street Address</Form.Label>
        <Form.Control
          type="text"
          name="bio.street_address"
          value={formData.patient.bio.street_address}
          onChange={handleChange}
          placeholder="123 Main St"
        />
      </Form.Group>
      
      <Form.Group controlId="addressLine1" className="mb-3">
        <Form.Label>Address Line 1</Form.Label>
        <Form.Control
          type="text"
          name="bio.address_line_1"
          value={formData.patient.bio.address_line_1}
          onChange={handleChange}
          placeholder="Apartment, suite, unit, building, floor, etc."
        />
      </Form.Group>
      
      <Form.Group controlId="addressLine2" className="mb-3">
        <Form.Label>Address Line 2</Form.Label>
        <Form.Control
          type="text"
          name="bio.address_line_2"
          value={formData.patient.bio.address_line_2}
          onChange={handleChange}
          placeholder="Additional address information"
        />
      </Form.Group>
      
      <Row className="mb-3">
        <Col md={4}>
          <Form.Group controlId="city">
            <Form.Label>City</Form.Label>
            <Form.Control
              type="text"
              name="bio.city"
              value={formData.patient.bio.city}
              onChange={handleChange}
              placeholder="City"
            />
          </Form.Group>
        </Col>
        
        <Col md={4}>
          <Form.Group controlId="state">
            <Form.Label>State</Form.Label>
            <Form.Control
              type="text"
              name="bio.state"
              value={formData.patient.bio.state}
              onChange={handleChange}
              placeholder="State"
            />
          </Form.Group>
        </Col>
        
        <Col md={4}>
          <Form.Group controlId="zipCode">
            <Form.Label>ZIP Code</Form.Label>
            <Form.Control
              type="text"
              name="bio.zip_code"
              value={formData.patient.bio.zip_code}
              onChange={handleChange}
              placeholder="ZIP Code"
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default AddressInfo;